import React from 'react';

const cfg = {
  live: { bg: '#FFEBEE', text: '#E53935', dot: '#E53935', label: 'LIVE', pulse: true },
  completed: { bg: '#E8F5E9', text: '#43A047', dot: '#43A047', label: 'COMPLETED' },
  scheduled: { bg: '#EEF1F6', text: '#5F6B80', dot: '#8892A6', label: 'UPCOMING' },
  ongoing: { bg: '#FFF3E0', text: '#E65100', dot: '#FB8C00', label: 'ONGOING', pulse: true },
  upcoming: { bg: '#EDE7F6', text: '#7B1FA2', dot: '#7B1FA2', label: 'UPCOMING' },
};

export default function StatusBadge({ status, size = 'sm' }) {
  const c = cfg[status] || cfg.scheduled;
  const isLg = size === 'lg';
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 5,
      padding: isLg ? '5px 12px' : '3px 10px',
      borderRadius: 6, fontSize: isLg ? 11 : 10,
      fontWeight: 800, letterSpacing: 0.8,
      fontFamily: "'Outfit', sans-serif",
      background: c.bg, color: c.text,
    }}>
      <span style={{
        width: 6, height: 6, borderRadius: '50%', background: c.dot, flexShrink: 0,
        ...(c.pulse ? { animation: 'pulse 1.5s infinite' } : {}),
      }} />
      {c.label}
    </span>
  );
}
